






























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import moment from 'moment'
import ChartOptionsMenu from './ChartOptionsMenu.vue'

@Component({
    components: {
        ChartOptionsMenu
    }
})
export default class DataTable extends Vue {
    @Prop({ required: true }) title!: string
    @Prop({ required: true }) loading!: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop({ required: true }) data!: any;

    localLoading = true
    items: object[] = [];
    colNames: ADMColumn[] = [];

    changeChart (chart: string) {
        this.$emit('change-chart', { index: this.data.widgetId, chart })
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} ${hours}:${minutes}`
    }

    isDate (text: string) {
        if (text && text.length > 0) {
            const valid = this.getDateFormat(text)
            if (
                !valid.includes('NaN') &&
        text &&
        text.includes('T') &&
        text.includes('Z')
            ) {
                return true
            }
        }
        return false
    }

    dateFormat (text: string) {
        if (this.isDate(text)) {
            text = moment(`${text}`).format('DD/MM/YYYY HH:mm')
        }
        return text
    }

    getReportData () {
        this.localLoading = true
        this.$store.dispatch('viewReport', {
            reportId: this.data.reportId.reportId,
            reportFilters: []
        })
            .then((resp) => {
                if (resp?.status === 200) {
                    this.formatData(resp.data)
                }
                this.localLoading = false
            })
            .catch((error) => {
                this.localLoading = false
                console.log(error)
            })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatData (data: any) {
        if (data.query.length > 0) {
            this.items = data.query
            this.colNames = []
            this.items = this.items.map((elemet) => {
                const itemData = Object.values(elemet)
                itemData.map((value) => {
                    const valid = this.isDate(value)
                    if (valid) {
                        value = moment(`${value}`).format('YYYY-MM-DD HH:mm')
                    }
                    const regex = /((\d+)((\.\d{1,2})?))$/
                    if (value && value.length > 0 && value.match(regex) && !valid) {
                        value = parseFloat(value)
                    }
                    return value
                })
                return elemet
            })
            const cols = Object.keys(data.query[0])
            cols.map((item) => {
                this.colNames.push({ text: `${item}`, value: `${item}` })
            })
        } else {
            this.colNames = []
            this.items = []
            this.$store.commit('reportError', {
                code: 1000,
                message: 'No data available'
            })
        }
    }

    @Watch('loading')
    ondialogPropChange () {
        this.localLoading = this.loading
    }

    mounted () {
        this.getReportData()
        setInterval(this.getReportData, 300000)
    }
}
